export const ProfessionalInfoGroupStepController = [
    '$scope', 'RegistrationService',
    function($scope, RegistrationService) {
        $scope.groupName = 'Professional Info';
        $scope.hideNav = false;
        $scope.withHero = false; // should we show a hero section
        $scope.autoAdvance = false; // if true, next-step button is auto-clicked
        $scope.finalStep = 4; // the last step number of this group
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/professionalInfo.html';
        $scope.employmentDatesOptional = false;

        // if the localStep is -1, we need to go to the very last step
        if ($scope.localStep === -1) {
            $scope.localStep = $scope.finalStep;
        }

        RegistrationService.getRegistrationSettings().then(function(d) {
            $scope.employmentDatesOptional = d.WhitelabelSettings.employmentDatesOptional;
            $scope.skipEmploymentInput = d.WhitelabelSettings['hideField:employment'];
            $scope.skipEducationInput = d.WhitelabelSettings['hideField:education'];
            $scope.skipConsultationTypes = d.WhitelabelSettings['hideField:consultationTypes'];

            switch ($scope.localStep) {
                case 0:
                    $scope.withHero = true;
                    $scope.minInputTop = 0;
                    if(d.WhitelabelSettings['registrationSkipProfessionalInfoSplash'])
                    {
                        $scope.skipThisStep();
                    }
                    break;
                case 1:
                    if ($scope.skipEmploymentInput) {
                        $scope.skipThisStep();
                        break;
                    }
                    $scope.$watch(function() {
                        return $scope.registrationData.get('EmploymentHistory').
                            isComplete($scope.employmentDatesOptional);
                    }, function(newVal) {
                        $scope.showNext = newVal;
                    });
                    break;
                case 2:
                    if ($scope.skipEducationInput) {
                        $scope.skipThisStep();
                        break;
                    }
                    $scope.$watch(function() {
                        return $scope.registrationData.get('Education').isComplete();
                    }, function(newVal) {
                        $scope.showNext = newVal;
                    });
                    break;
                case 4:
                    if (!$scope.registrationSettings.Verticals.get(5)) {
                        $scope.skipThisStep();
                        break;
                    }
                // no break;
                case 3:
                    if ($scope.skipConsultationTypes.skip) {
                        if ($scope.skipConsultationTypes.default !== null ) {
                            $scope.registrationData.VerticalServices.reset();
                            $scope.skipConsultationTypes.default.forEach(verticalServiceId => {
                                $scope.registrationData.VerticalServices.add(d.VerticalServices.get(verticalServiceId));
                            });
                            $scope.goToNextStep(false);
                        } else {
                            $scope.skipThisStep();
                        }
                        break;
                    }
                    $scope.$watch('registrationData.VerticalServices.length', function(newVal) {
                        $scope.showNext = newVal >= 1;
                    });
                    break;
            }
        });

    },
];
